import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><span style={{
              "display": "inline-block",
              "verticalAlign": "middle"
            }}><img parentName="td" {...{
                "src": "/commerce/webapi/assets/ed68751c4fb5db8844632592ca2b5df8/adobe-logo.svg",
                "alt": "Adobe Commerce feature",
                "style": {
                  "height": "20px",
                  "marginRight": "8px",
                  "verticalAlign": "middle"
                }
              }}></img></span><span style={{
              "display": "inline-block",
              "verticalAlign": "middle"
            }}><strong>{`Exclusive feature only in Adobe Commerce`}</strong>{` (`}<a href="https://experienceleague.adobe.com/docs/commerce-admin/user-guides/home.html#product-editions">{`Learn more`}</a>{`)`}</span></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      